<template>
    <b-card no-body class="m-0">
        <b-card-header>
            <span>Cancel Tab</span>
        </b-card-header>
        <b-card-body>
            <p>Select cancellation reason to notify the customer</p>
            <b-form-group>
                <b-form-checkbox-group stacked id="checkbox-group-2" v-model="selected" name="flavour-2">
                    <b-form-radio
                        v-for="(item, index) in cancelData"
                        :key="index"
                        class="my-3"
                        :value="item.Text"
                        v-model="CancelReason"
                        name="CancelReason"
                    >{{item.Text}}</b-form-radio>
                </b-form-checkbox-group>
            </b-form-group>
            <div class="d-flex flex-row justify-content-between">
                <b-btn class="processBtnModal" @click="cancelOrder" :disabled="!CancelReason">
                    <span v-if="loadingBtn">
                        <font-awesome-icon spin icon="circle-notch" class="align-middle"/>
                    </span>
                    <span v-else>
                        Cancel Tab and Notify Customer
                    </span>
                </b-btn>
                <b-btn class="cancelBtnModal" @click="closeCancel">Never mind</b-btn>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
    export default {
        name: "cancelOrder",
        props: {
            cancelData: {
                required: true
            },
            loadingBtn: {
                required: true
            }
        },
        data () {
            return {
                CancelReason : null
            }
        },
        methods: {
            closeCancel () {
                this.$emit('closeCancel')
            },
            cancelOrder () {
                if (this.CancelReason === null) {
                    this.$showError('please select one cancel reason')
                } else {
                    this.$emit('cancelOrder', this.CancelReason)
                }
            }
        }
    }
</script>

<style scoped>

</style>
